export const rejectionWarningMessages = {
  instant:
    'Rechazar estos productos activará el proceso de cobro de deuda. Reveni contactará al cliente para recuperar el importe correspondiente a los artículos rechazados. ¿Quieres continuar?',
  generic: 'Esta acción no se podrá deshacer. ¿Quieres continuar?',
}
